<template>
  <div class="publish-goods-container">
    <div>
      <h2><span class="product-tips" @click="$router.back()">商品管理</span> / {{ pageTitle }}</h2>
    </div>
    <WenXinTips />
    <BaseInfo ref="baseInfoRef" />
    <SaleInfoNormal ref="saleInfoNormalRef" />
    <PayInfo ref="payInfoRef" />
    <DeliveryInfo ref="deliveryInfoRef" />
    <GraphicInfo ref="graphicInfoRef" />
    <div class="pad50"></div>
    <div class="pad50"></div>
    <div class="flex bg-white pad30-tb border-t fixed justify-center button-group">
      <el-button @click="cancelClick">取消</el-button>
      <el-button type="primary" @click="onSubmit">发布</el-button>
    </div>
  </div>
</template>

<script>
import { goodsSave } from "@/api/publishGoods/publishGoods";
import WenXinTips from "./components/WenXinTips.vue";
import BaseInfo from "./components/BaseInfo.vue";
import PayInfo from "./components/PayInfo.vue";
import DeliveryInfo from "./components/DeliveryInfo.vue";
import GraphicInfo from "./components/GraphicInfo.vue";
import SaleInfoNormal from "./components/SaleInfoNormal.vue";

export default {
  components: {
    WenXinTips,
    BaseInfo,
    SaleInfoNormal,
    PayInfo,
    DeliveryInfo,
    GraphicInfo,
  },
  data() {
    return {
      spuId: this.$route.query.spuId,
    };
  },
  computed: {
    pageTitle() {
      return this.spuId ? "编辑商品" : "新建商品";
    },
  },
  created() {
    if (this.spuId) {
      this.$store.commit("publishGoods/publishGoods/saveSpuId", this.spuId);

      this.loadEditProductDetail(this.spuId);
    }
  },
  methods: {
    async loadEditProductDetail(spuId) {
      //220928131979001
      //337649472946
      //221110093378001
      //221114161278001
      // 单规格 221104105378001
      //多规格 oa spuid 2211111558340002077
      //单规格oa商品，spuId: 220920130878001

      this.$store.dispatch("publishGoods/publishGoods/loadEditProductDetail", spuId);
    },
    cancelClick() {
      // this.$router.back();
      window.location.href = `${process.env.VUE_APP_APP}v/mj/managegoods?appid=1&isShowTitle=1`;
      // this.$router.push("/mj/managegoods");
    },
    async onSubmit() {
      let baseInfoObj = await this.$refs.baseInfoRef.subMitCheck();
      if (!baseInfoObj) {
        return;
      }
      console.log("基本信息", baseInfoObj);

      let saleInfoObj = this.$refs.saleInfoNormalRef.subMitCheck();
      if (!saleInfoObj) {
        return;
      }
      console.log("销售信息", saleInfoObj);

      let payInfoObj = this.$refs.payInfoRef.subMitCheck();
      console.log("支付信息", payInfoObj);

      let deliveryObj = await this.$refs.deliveryInfoRef.subMitCheck();
      if (!deliveryObj) {
        return;
      }
      console.log("物流信息", deliveryObj);

      let graphicObj = await this.$refs.graphicInfoRef.subMitCheck();
      if (!graphicObj) {
        return;
      }
      console.log("图文信息", graphicObj);

      const saveObj = {
        isShowPrice: 1,
        ...baseInfoObj,
        ...saleInfoObj,
        ...payInfoObj,
        ...deliveryObj,
        ...graphicObj,
        spuId: this.spuId || "",
      };

      const loading = this.$loading({
        lock: false,
        text: "提交中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        const saveResult = await goodsSave(saveObj);

        if (saveResult.code === "0") {
          this.$message.success(`${saveResult.msg}`);

          setTimeout(() => {
            window.location.href = `${process.env.VUE_APP_APP}v/mj/managegoods?appid=1&isShowTitle=1`;
          }, 1000);
          // this.$router.push("/mj/managegoods");
        } else {
          this.$message.error(`${saveResult.msg}`);
        }
      } catch (error) {
        this.$message.error("系统故障请稍后再试");
      } finally {
        loading.close();
      }
    },
  },
};
</script>
<style lang="scss">
@import "./changeOuterMainColor.scss";
</style>

<style lang="scss" scoped>
@import "./changeMainColor.scss";

.publish-goods-container {
  padding: 20px;
  .product-tips {
    color: lightslategray;
    cursor: pointer;
    &:hover {
      color: rgb(51, 51, 51);
    }
  }
}
.button-group {
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
}
</style>
